<template>
  <div class="refresh-alert-container">
    <v-alert
      v-model="show"
      border="left"
      colored-border
      color="blue"
      elevation="2"
      origin="left"
      transition="slide-x-transition"
    >
      <template v-slot:prepend>
        <v-icon class="me-2" size="24" color="blue">
          mdi-information-outline
        </v-icon>
      </template>
      <p
        class="mb-0 font-weight-600 font-size-14 blue-grey--text text--darken-3 text-line-heigt"
      >
        {{ $t('common.new_version_published') }}
      </p>
      <p
        class="mb-0 font-size-14 blue-grey--text text--darken-3 mt-1 text-line-heigt"
      >
        {{ $t('boards.refresh_alert') }}
      </p>
      <v-btn
        plain
        small
        class="refresh-board-button-opacity pa-0 mt-2"
        color="primary"
        elevation="0"
        @click="$emit('refresh')"
      >
        {{ $t('common.button.refresh') }}
      </v-btn>

      <template v-slot:append>
        <v-icon
          size="24"
          class="ms-3"
          color="blue-grey"
          @click="$emit('dismiss')"
          >mdi-close</v-icon
        >
      </template>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'RefreshAlert',

  props: {
    show: Boolean,
  },
}
</script>

<style scoped lang="scss">
.refresh-alert-container {
  position: fixed;
  left: 60px;
  bottom: 12px;
  z-index: 6;

  .v-alert {
    width: 364px;
    .text-line-heigt {
      line-height: 24px;
    }
  }
}
</style>
<style lang="scss">
.refresh-alert-container {
  .v-alert .v-alert__wrapper {
    align-items: flex-start !important;
  }
  .refresh-board-button-opacity .v-btn__content {
    opacity: 1 !important;
    justify-content: start;
  }
}
</style>
